module.exports = __webpack_public_path__ + "img/programme4.d74e7507.png";